import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { UserService } from '@nrwl/common-lib';


@Component({
  selector: 'nrwl-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit, OnDestroy {

  private readonly unsubscribe: Subject<void> = new Subject();

  tabs: any = [];

  constructor(
    private readonly userService: UserService
  ) { }

  ngOnInit() {
    this._loadUserBoard();
  }

  private _loadUserBoard() {
    this.userService.getUserBoard$()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(result => {
        this.tabs = result.tabs;
      }, error => {}, () => {});
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
